<template>
  <header :class="['header', { scrolled: isScrolled }, headerClass]">
    <div class="header__container">
      <button class="nav__toggle" @click="toggleMenu" aria-label="Toggle navigation">
          <div class="burger-icon" :class="{ open: isMenuOpen }"></div>
        </button>
        <div class="header__logo">
          <router-link :to="localizedRoute('home')" >
              <img src="/logo/logo.webp" alt="Logo" class="logo-img" />
          </router-link>
        </div>
     

      <nav class="nav">


        <div :class="['nav__list', { 'nav__list--mobile': isMenuOpen }]">
          <router-link
            v-for="menuItem in menuItemsList"
            :key="menuItem.name"
            :to="{ name: menuItem.name, params: { locale: $i18n.locale } }"
            @click="closeMenu"
          >
            {{ $t(`menu.${menuItem.titleLabel}`) }}
          </router-link>
        </div>
      </nav>


      <div class="menu__item lang custom-dropdown" @click.stop="toggleDropdown">
        <span class="selected-lang">{{ selectedLanguage }}</span>
        <div class="arrow" :class="{ open: isDropdownOpen }"></div>
        <ul v-if="isDropdownOpen" class="dropdown-menu">
          <li v-for="lang in languages" :key="lang.code" @click.stop="changeLocale(lang.code)">
            {{ lang.code.toUpperCase() }}
          </li>
        </ul>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: "HeaderComponent",
  data() {
    return {
      menuItemsList: [
        { name: "home", titleLabel: "home" },
        { name: "about", titleLabel: "about" },
        { name: "services", titleLabel: "services" },
        { name: "vacancies", titleLabel: "vacancies" },
        { name: "contacts", titleLabel: "contacts" }
      ],
      isScrolled: false,
      isMenuOpen: false,
      isDropdownOpen: false,
      selectedLanguage: "EN", 
      languages: [
        { code: "en" },
        { code: "ru" },
        { code: "ro" },
      ],
    };
  },
  computed: {
    headerClass() {
      return this.$route.name === "home" ? "header-home" : "header-other";
    },
  },
  methods: {
    handleScroll() {
      this.isScrolled = window.scrollY > 50;
    },
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
      document.body.style.overflow = this.isMenuOpen ? "hidden" : "";
    },
    closeMenu() {
      this.isMenuOpen = false;
      document.body.style.overflow = "";
    },
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    closeDropdown(event) {
      if (!this.$el.contains(event.target)) {
        this.isDropdownOpen = false;
      }
    },
    changeLocale(lang) {
      this.$i18n.locale = lang;
      this.selectedLanguage = lang.toUpperCase(); 
      this.isDropdownOpen = false;

      const currentPath = this.$route.path;
      const regex = /^\/(en|ru|ro)/;
      const newPath = currentPath.replace(regex, `/${lang}`);
      this.$router.push({ path: newPath });
    },
    localizedRoute(name) {
      const locale = this.$i18n.locale;
      const localizedPath = this.$i18n.t(`url.${name}`);
      return localizedPath ? (name === "home" ? `/${locale}` : `/${locale}/${localizedPath}`) : `/${locale}`;
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("click", this.closeDropdown); 
    const currentLang = this.languages.find((l) => l.code === this.$i18n.locale);
    if (currentLang) {
      this.selectedLanguage = currentLang.code.toUpperCase();
    }
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("click", this.closeDropdown);
  },
};
</script>



